import { render } from "./addintransit.vue?vue&type=template&id=0bae64d6"
import script from "./addintransit.vue?vue&type=script&lang=js"
export * from "./addintransit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__